import { atom } from "recoil";

const chargesAtom = atom({
  key: 'charges',
  default: {
    payload: [],
    loading: false,
    total: 0
  }
});



const crudChargesAtom = atom({
  key: 'crudCharges',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});


export { crudChargesAtom, chargesAtom};